import React, { CSSProperties, FC, useEffect, useRef, useState } from 'react';
import colors from '../../styles/colors.scss';
import font from '../../styles/typography.scss';
import { parseNameFields } from '../../utils/string-manipulation';

const { REACT_APP_CALENDLY_API_URL } = process.env;

interface Props {
  email?: string;
  name?: string;
  style: CSSProperties;
}

export const CalendlyWidget: FC<Props> = ({ style, email, name }) => {
  const primaryColor = colors.primaryColor.replace('#', '');
  const textColor = font.textColorDark.replace('#', '');
  const [isCalendlyReady, setCalendlyReady] = useState(!!window.Calendly);
  const widgetContainerRef = useRef<HTMLDivElement | null>(null);
  const dataUrl = REACT_APP_CALENDLY_API_URL + `?text_color=${textColor}&primary_color=${primaryColor}`;
  const [patientFirstName, patientLastName] = parseNameFields(name);

  useEffect(() => {
    if (window.Calendly) {
      const parentElement = widgetContainerRef.current;
      if (!parentElement) {
        return;
      }
      parentElement.innerHTML = '';

      window.Calendly.initInlineWidget({
        url: dataUrl,
        parentElement,
        prefill: { email, name: `${patientFirstName} ${patientLastName}`, first_name: patientFirstName, last_name: patientLastName },
      });
    } else {
      const head: HTMLHeadElement = document.querySelector('head')!;
      const script = document.createElement('script');
      const calendlyScriptId = 'calendly_external_widget_script';

      script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
      script.setAttribute('id', calendlyScriptId);
      script.onload = () => {
        setCalendlyReady(true);
      };
      head.appendChild(script);

      return () => {
        head.removeChild(document.getElementById(calendlyScriptId)!);
      };
    }
  }, [dataUrl, email, patientFirstName, patientLastName, isCalendlyReady]);

  return <div ref={widgetContainerRef} className='calendly-inline-widget' data-auto-load={false} style={style} />;
};
